<template>

  <panel-navigation>
    <dialog-add-template ref="dialogAddTemplate"></dialog-add-template>

    <div class="float-right mb-3">
        <div class="border-1 border-blue bg-blue text-white text-xs text-bold px-4 py-2 rounded cursor-pointer float-right ml-2" @click="addTemplate();" style="margin-top: -7px;">+ NEW TEMPLATE</div>
    </div>

    <h1 class="text-lg font-semibold mb-3">SMS Templates</h1>

    <div style="clear: both;"></div>
    
    <v-skeleton-loader v-if="fetchingTemplates" type="article, article, article"></v-skeleton-loader>

    <div class="dashboard-box" v-if="!fetchingTemplates && templates.length == 0">
      <v-card
        class="pa-2"
        tile
      >
        <div class="p-3">

          <br /><br /><br /><br />

          <div class="dashboard-box-iconsquare">
            <div class="dashboard-box-icon-background"></div>
            <div class="dashboard-box-icon">
              <i class="mdi mdi-file-document-multiple-outline"></i>
            </div>
          </div>

          <div style="text-align: center;">
            <div class="pt-2 pb-2">
              <strong>No SMS Templates Yet</strong>
            </div>

            <div class="text-sm mb-4 text-gray-600">
              You have no templates yet. Use our tools to add templates.
            </div>

            <br />

            <div class="border-1 border-blue bg-blue text-white text-xs text-bold px-4 py-2 inline-block rounded cursor-pointer" @click="addTemplate()" style="margin-top: -5px;"><i class="fa fa-plus mr-2"></i> ADD SMS TEMPLATE</div>
          </div>
          
          <br /><br /><br /><br /><br />
        </div>
      </v-card>
    </div>

    <template v-if="!fetchingTemplates && templates.length > 0">

      <draggable v-model="these_templates" tag="div" class="lf-templates-wrapper" @change="logReorder">
        <div draggable v-for="template in these_templates" :key="template.id" class="lf-templates-item">
          <v-card
            class=""
            tile
          >
            <div style="padding: 15px; background: #f7fafc;">
              <div style="float: left;">
                <svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.5495 4.28906H17.5719C18.284 4.28906 18.8599 4.88999 18.8599 5.63303V9.832C18.8599 10.5732 18.284 11.1741 17.5737 11.1741H15.121C15.064 11.5965 15.0161 12.3434 15.2608 13.215C15.3933 13.6874 15.5792 14.0848 15.7705 14.4054C15.9325 14.6781 15.6601 15.0084 15.3785 14.8815C14.7566 14.6012 14.3371 14.2613 14.1016 14.0445C12.6388 12.6985 12.3794 10.7402 12.2984 10.1373C12.2819 10.0067 12.2709 9.89916 12.2635 9.83005L12.2634 5.63108C12.2634 4.89006 12.8394 4.2891 13.5496 4.2891L13.5495 4.28906Z" fill="#3A9BDB"/>
                  <path d="M5.42796 4.28906H9.44836C10.1604 4.28906 10.7363 4.88999 10.7363 5.63303V9.832C10.7363 10.5732 10.1604 11.1741 9.45014 11.1741H6.99741C6.94043 11.5965 6.89255 12.3434 7.13731 13.215C7.26977 13.6874 7.45562 14.0848 7.64699 14.4054C7.80897 14.6781 7.53661 15.0084 7.25501 14.8815C6.63302 14.6012 6.2136 14.2613 5.97808 14.0445C4.51528 12.6985 4.25591 10.7402 4.17491 10.1373C4.15836 10.0067 4.14732 9.89916 4.14 9.83005V5.63313C4.14 4.89009 4.71589 4.28917 5.42797 4.28917L5.42796 4.28906Z" fill="#3A9BDB"/>
                </svg>
              </div>

              <div class="lf-templates-text">
                {{ getPreview(template.content) }}
              </div>

              <div style="float: right;">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.86129 4.28906H5.66403C4.92099 4.28906 4.32007 4.88999 4.32007 5.63303V9.832C4.32007 10.5732 4.92099 11.1741 5.66218 11.1741H8.22154C8.28101 11.5965 8.33096 12.3434 8.07556 13.215C7.93735 13.6874 7.74342 14.0848 7.54372 14.4054C7.3747 14.6781 7.6589 15.0084 7.95275 14.8815C8.60178 14.6012 9.03944 14.2613 9.2852 14.0445C10.8116 12.6985 11.0822 10.7402 11.1668 10.1373C11.184 10.0067 11.1956 9.89916 11.2032 9.83005L11.2033 5.63108C11.2033 4.89006 10.6023 4.2891 9.86121 4.2891L9.86129 4.28906Z" fill="#3A9BDB"/>
                  <path d="M18.336 4.28906H14.1408C13.3978 4.28906 12.7969 4.88999 12.7969 5.63303V9.832C12.7969 10.5732 13.3978 11.1741 14.139 11.1741H16.6983C16.7578 11.5965 16.8078 12.3434 16.5524 13.215C16.4142 13.6874 16.2202 14.0848 16.0205 14.4054C15.8515 14.6781 16.1357 15.0084 16.4296 14.8815C17.0786 14.6012 17.5162 14.2613 17.762 14.0445C19.2884 12.6985 19.5591 10.7402 19.6436 10.1373C19.6608 10.0067 19.6724 9.89916 19.68 9.83005V5.63313C19.68 4.89009 19.0791 4.28917 18.336 4.28917L18.336 4.28906Z" fill="#3A9BDB"/>
                </svg>
              </div>

              <div style="clear: both;"></div>
            </div>

            <div style="float: right;">
              <v-menu
                bottom
                left
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    dark
                    icon
                    v-bind="attrs"
                    v-on="on"
                    class="ml-3"
                    color="grey darken-1"
                  >
                    <i class="mdi mdi-dots-vertical" style="font-size: 18px;"></i>
                  </v-btn>
                </template>

                <v-list class="table-menu-actions">
                  <v-list-item class="hover:bg-gray-200"><v-list-item-title><a href="javascript: void(0);" @click="copyTemplate(template)"><span class="table-menu-action-icon"><i class="fa fa-copy"></i></span> Duplicate</a></v-list-item-title></v-list-item>
                  <v-list-item class="hover:bg-gray-200"><v-list-item-title><a href="javascript: void(0);" @click="editTemplate(template)"><span class="table-menu-action-icon"><i class="fa fa-pen"></i></span> Edit</a></v-list-item-title></v-list-item>
                  <v-list-item class="hover:bg-gray-200"><v-list-item-title><a href="javascript: void(0);" @click="deleteTemplate(template)"><span class="table-menu-action-icon"><i class="fa fa-trash"></i></span> Delete</a></v-list-item-title></v-list-item>
                </v-list>
              </v-menu>
            </div>

            <div style="color: #19233A; font-weight: bold; font-size: 14px; padding: 15px; padding-bottom: 0px;">{{  template.title  }}</div>

            <div style="color: #757B89; font-size: 12px; padding: 15px;">Last Edit {{ getLastUpdated(template.updated_at) }}</div>

            <div style="clear: both;"></div>
          </v-card>
        </div>
        <div style="clear: both;"></div>
      </draggable>

    </template>

  </panel-navigation>

</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios';
import PanelNavigation from '@/components/PanelNavigation.vue'
import MenuTemplateActions from '@/components/menus/menuTemplateActions.vue'
import DialogAddTemplate from '@/components/dialogs/templates/addTemplate.vue'
import moment from 'moment-timezone'
import draggable from 'vuedraggable'

export default {
  metaInfo () {
    return {
      title: "Templates | " + this.$appName
    }
  },
  components: {
    PanelNavigation,
    MenuTemplateActions,
    DialogAddTemplate,
    draggable
  },
  data() {
    return {
      selectedIds: [],
      these_templates: []
    }
  },
  computed: {
    ...mapState({
      me: state => state.me.me,
      templates: state => state.templates.templates,
      fetchingTemplates: state => state.templates.fetchingTemplates
    })
  },
  methods: {
    getLastUpdated(date) {
      // Dec 05, 2022
      return moment(String(date)).format('MMM DD, YYYY');
    },
    async bulkDelete() {
      await this.$store.dispatch('templates/bulkDelete', {ids: this.selectedIds})
      this.$store.dispatch('templates/fetch')
      this.selectedIds = []
    },


    async deleteTemplate(template) {
      await this.$store.dispatch('templates/bulkDelete', {ids: [template.id]})
      this.$store.dispatch('templates/fetch')
      this.selectedIds = []
    },

    getPreview(content) {
        // return content;
        return (content.length > 100) ? content.substring(0, 100) + "..." : content;
    },

    addTemplate() {
        this.$refs.dialogAddTemplate.addTemplate();
        this.$refs.dialogAddTemplate.show();
    },

    editTemplate(template) {
        this.$refs.dialogAddTemplate.editTemplate(template);
        this.$refs.dialogAddTemplate.show();
    },

    async copyTemplate(template) {
      let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/templates/copy`, {
        id: template.id
      }, {
          headers: {
            'Authorization': 'Bearer ' + this.$store.state.auth.jwt
          }
      })

      await this.$store.dispatch('templates/fetch');

      let copiedTemplate = response.data.template;
      this.editTemplate(copiedTemplate);
    },

    async logReorder() {
      let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/templates/update-order`, {
        these_templates: this.these_templates
      }, {
          headers: {
            'Authorization': 'Bearer ' + this.$store.state.auth.jwt
          }
      })

      await this.$store.dispatch('templates/fetch');
    }
  },
  created() {
    this.$store.state.templates.fetchingTemplates = true
    this.$store.dispatch('templates/fetch')
  },

  watch: {
    templates: function(val, oldVal) {
      this.these_templates = JSON.parse(JSON.stringify(this.templates));
    }
  }
}
</script>

<style lang="scss" scoped>

.btn-invite {
  background-color: #00ad9e;
}

table tbody tr {
  transition: all 0.1s linear;
}

table tbody tr:hover {
  background-color: rgb(245, 245, 245);
}

.v-list-item {
  min-height: 27px;
  font-size: 13px;
}

.lf-templates-wrapper {

}

.lf-templates-item {
  float: left;
  width: 23%;
  // margin-top: 0px;
  margin-right: 2.6%;
  margin-bottom: 20px;
}

.lf-templates-item:nth-child(4n) {
  float: right;
  margin-right: 0px;
}

.lf-templates-text {
  clear: both; padding-top: 25px; padding-bottom: 25px; text-align: center; color: #19233A; font-size: 14px; height: 100px; vertical-align: middle;
}
</style>
